<h2 mat-dialog-title>{{ data?.title }}</h2>
<mat-dialog-content class="mb-2" style="overflow: visible">
  <p [innerHTML]="data?.newsRecords[0]?.description | safeHtml"></p>
  <p *ngIf="data?.newsRecords[0]?.videoUrl">
    <a (click)="goToVideo()"><strong><em>Link al video</em></strong></a>
  </p>
  <mat-checkbox
    color="primary"
    disableRipple="true"
    [(ngModel)]="checked"
    style="transform: scale(0.8); transform-origin: top left; display: inline-block"
  >
    Non ricordarmelo più
  </mat-checkbox>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCloseClick()">Chiudi</button>
</mat-dialog-actions>
